module.exports = __webpack_public_path__ + "img/shopping-cart.572d248e.svg";